import { useEventTracker } from "hooks/useEventTracker";
import { useSsoUrls } from "hooks/useSsoUrls";

import Star from "components/Icons/star_solid.svg";
import TrackImpression from "components/TrackImpression";

type Props = {
  isGated: boolean;
};

export default ({ isGated }: Props) => {
  const { publishEvent } = useEventTracker();
  const { signInUrl, signUpUrl } = useSsoUrls();

  return (
    <>
      <Star width="19" height="18" className="mx-auto mb-lg" />
      <h3 data-testid="logged-out-header">
        {isGated ? "Unlock your strain scores" : "Save your bud preferences"}
      </h3>
      <p className="mb-lg">
        Create a free account to see how you match up to every single strain.
      </p>
      <TrackImpression
        trackingFunction={() =>
          publishEvent({
            action: "impression",
            category: "Strain Quiz Results",
            label: "create account",
          })
        }
      >
        <a
          onClick={() => {
            publishEvent({
              action: "click",
              category: "Strain Quiz Results",
              label: "create account",
            });
          }}
          className="button block mx-auto"
          href={signUpUrl}
          data-testid="create-account"
        >
          create free account
        </a>
      </TrackImpression>
      <TrackImpression
        trackingFunction={() =>
          publishEvent({
            action: "impression",
            category: "Strain Quiz Results",
            label: "sign in",
          })
        }
      >
        <a
          onClick={() => {
            publishEvent({
              action: "click",
              category: "Strain Quiz Results",
              label: "sign in",
            });
          }}
          className="block p-lg underline font-bold"
          href={signInUrl}
          data-testid="sign-in"
        >
          sign in
        </a>
      </TrackImpression>
    </>
  );
};
